// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Cw06L{display:flex;flex-direction:column;gap:24px;padding:32px;background:#fff;height:100%;box-sizing:border-box}.dPKe_{display:flex;flex-direction:column;gap:8px}.ghcEU{max-height:64px;max-width:200px;object-fit:contain}.YZusg{display:flex;flex-direction:column;gap:12px}.DaJZL{display:flex;justify-content:space-between}.bgs_k{display:flex;justify-content:space-between;align-items:center;margin-top:16px;padding-top:16px;border-top:1px solid #e0e0e0}.ncSPx{background:none;border:none;color:#1a73e8;cursor:pointer;padding:0;text-align:left;text-decoration:underline;font:inherit}.xZYhw{margin-top:auto;color:#666}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"panel": `Cw06L`,
	"vendorBlock": `dPKe_`,
	"vendorLogo": `ghcEU`,
	"detailsBlock": `YZusg`,
	"row": `DaJZL`,
	"amountRow": `bgs_k`,
	"viewInvoiceLink": `ncSPx`,
	"poweredBy": `xZYhw`
};
export default ___CSS_LOADER_EXPORT___;
